// chat-helper-completion slug (#2): per-message timestamps in the chat room.
// The UI shows a compact RELATIVE label ("2m ago") with the full local
// date-time available on hover (title attr) — see ChatInterface's room/local
// message bubbles. `nowMs` is threaded in (rather than read here) so a single
// shared ticker in ChatInterface re-renders every label in step, instead of
// each message owning its own clock.

export function relativeTime(ms, nowMs = Date.now()) {
  if (!ms) return '';
  const diff = Math.max(0, nowMs - ms);
  const sec = Math.floor(diff / 1000);
  if (sec < 45) return 'just now';
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const day = Math.floor(hr / 24);
  if (day < 7) return `${day}d ago`;
  // Older than a week, "5w ago" stops being useful — show a short date.
  return new Date(ms).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

export function absoluteTime(ms) {
  if (!ms) return '';
  return new Date(ms).toLocaleString();
}
